























helpers = require('../../helpers.coffee')

view_model =
  props: ['template_category']
  data: ->
    name: @template_category.name
    editing: false

  methods:
    submit: ->
      @$validator.validateAll({@name}).then (success) =>
        @updateTemplateCategory() if success

    updateTemplateCategory: ->
      Loader.on()
      params = {id: @template_category.id, @name}
      new TemplateCategoriesResource().update(@updateTemplateCategorySuccess, @handleApiErrors, params)

    updateTemplateCategorySuccess: (data) ->
      Loader.off()
      alertify.success 'Salvo com sucesso'
      @editing = false
      @trackIntercomTemplateCategoryUpdate(data.template_category)
      @$emit('updated', data.template_category)

    destroyTemplateCategory: ->
      @$emit('destroy', @template_category)

    trackIntercomTemplateCategoryUpdate: (template_category) ->
      metadata = [
        { attribute: 'name', key: 'Nome', function: 'changedFromTo' }
      ]
      IntercomCtrl.trackEventMetadata('Atualizou uma categoria de template', metadata, @template_category, template_category)

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/template_categories/list_item.vue